import React from "react";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import HeroSection from "../../../components/HeroSection/HeroSection";
import HeroCaption from "../../../components/HeroCaption/HeroCaption";

import FacultyResponsive from "../../../components/FacultyResponsive/FacultyResponsive";
import CoursesResponsive from "../../../components/CoursesResponsive/CoursesResponsive";
import DepartmentInfoResponsive from "../../../components/DepartmentInfoResponsive/DepartmentInfoResponsive";
import DepartmentAboutInfoResponsive from "../../../components/DepartmentAboutInfoResponsive/DepartmentAboutInfoResponsive";
import HODResponsive from "../../../components/HODResponsive/HODResponsive";

const hodData = {
	imageUrl: "",
	designation: "Head of the Department",
	name: "Prof. Name",
	feedback: `Dear Students,
	I would like to take this opportunity to encourage you all to stay motivated and focused on your academic pursuits. The Electrical and Electronics Engineering (EEE) Department at NIET is dedicated to providing you with a comprehensive education that equips you with the skills and knowledge you need to succeed in the industry.
	Our faculty members are committed to providing you with a challenging and rigorous curriculum that prepares you for a successful career in the field of electrical and electronics engineering. We are here to support you and guide you through your academic journey.
	I urge you to make the most of the resources and facilities available to you and to take advantage of the various opportunities provided by our department, including co-curricular activities and industry collaborations.
	Stay focused, stay motivated, and never stop learning.
	
    `,
};

const ElectricalElectronicsPage = () => {
	return (
		<PageWrapper className="mt-n6">
			<HeroSection className="bg-page-background-7">
				<HeroCaption
					title="Electrical & Electronics Department"
					position="bottom-left"
					breadcrumb={true}
					breadcrumbPrefix="Home"
				/>
			</HeroSection>
			<DepartmentInfoResponsive
				title={"Electrical & Electronics"}
				desc={`The Electrical and Electronics Engineering (EEE) Department at NIET is dedicated to providing a comprehensive education in the field of electrical and electronics engineering. Our department offers a range of programs and courses designed to equip students with the skills and knowledge they need to succeed in the industry.

`}
			/>
			<HODResponsive hodData={hodData} />
			<DepartmentAboutInfoResponsive
				title={"About department"}
				desc={`The Electrical and Electronics Engineering (EEE) Department at NIET is dedicated to providing a comprehensive education in the field of electrical and electronics engineering. Our department offers a range of programs and courses designed to equip students with the skills and knowledge they need to succeed in the industry.
				Our faculty members are experts in their respective fields and have extensive experience in both academia and industry. They are committed to providing students with a challenging and rigorous curriculum that prepares them for successful careers in the field of electrical and electronics engineering.
				Our EEE Department offers a B.Tech in Electrical Engineering program that covers a wide range of topics including electrical circuits, power systems, electrical machines, control systems, instrumentation, and electrical and electronics design. We also offer elective courses in emerging areas such as renewable energy, power electronics, and artificial intelligence, allowing students to specialize in their area of interest.
				Our department is equipped with state-of-the-art facilities, including electrical and electronics labs, simulation tools, and equipment, to support students' practical learning experience. Our faculty members work closely with students to provide hands-on training and real-world experience, preparing them for successful careers in the industry
				We also encourage students to participate in co-curricular activities such as robotics competitions, technical paper presentations, and project exhibitions, providing them with opportunities to showcase their skills and talents, and network with industry professionals.
				
                
`}
			/>
		</PageWrapper>
	);
};

export default ElectricalElectronicsPage;
